import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import schemeService from "../services/Scheme.Service"
export const createScheme = createAsyncThunk("/scheme/save", async (params, thunkAPI)=>{
    try{
        const data = await schemeService.save(params);
        return data;
    }catch(exception){
        if (typeof exception.response === "undefined") {
            return exception
        }
        return thunkAPI.rejectWithValue(exception?.response?.data)
    }
});

export const getSchemeList = createAsyncThunk("/scheme/list", async (params, thunkAPI)=>{
    try{
        let pageData =  Object.assign({}, params.data)
        const data = await schemeService.getList(pageData);
        return data;
    }catch(exception){
        if (typeof exception.response === "undefined") {
            return exception
        }
        return thunkAPI.rejectWithValue(exception?.response?.data)
    }
});

const initialState = {
    list:[],
    totalData:0,
    editData:{},
    errors:false,
    success:false,
    loading:false,
    message:""
}

const schemeSlice = createSlice({
        name: "scheme",
        initialState,
        reducers: {
            reset:(state,action) =>{
                if(Object.keys(action.payload) > 0){
                return {
                    ...initialState,
                    ...action.payload
                }
                }else{
                    return  initialState
                }
                
            },
            resetApiStatus:(state) => {
                return {
                    ...initialState,
                    errors:false,
                    success:false,
                    loading:false,
                    message:false
                }
            },
        },
        extraReducers: {
            [getSchemeList.pending] : (state) => {
                state.loading = true
                state.errors = false
                state.success = false
            },
            [getSchemeList.fulfilled] : (state, action) => {
                state.loading = false;
                state.list = action.payload.docs
                state.totalCount = action.payload.totalDocs
            },
            [getSchemeList.rejected] : (state, action) => {
                state.loading = false;
                state.success = false
                state.message = action.payload.msg  
            },
            [createScheme.pending] : (state) => {
                state.loading = true
                state.errors = false
                state.success = false
            },
            [createScheme.fulfilled] : (state, action) => {
                const data = action.payload;
                state.loading = false;
                state.message = data.msg;    
                state.success = true;
            },
            [createScheme.rejected] : (state, action) => {
                state.loading = false;
                state.success = false
                state.message = action.payload.msg  
            }
        }

})
export const { reset, resetApiStatus, setEditData } = schemeSlice.actions;
export default schemeSlice.reducer 